import { Component, createRef } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import HeaderSistema from "./components/HeaderSistema";
import Constante from "../../util/Constante";
import Util from "../../util/Util";
import Pessoa from "lirida-back-service/Servicos/Pessoa/Pessoa";
import PessoaService from "lirida-back-service/Servicos/Pessoa/PessoaService";
import Endereco from "lirida-back-service/Servicos/Endereco/Endereco";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

export default class ProfissionalDetalhe extends Component {
  toast = createRef();
  constante = new Constante();
  util = new Util();
  pessoaService = new PessoaService(this.constante.token, this.constante.url_base);

  state = {
    pessoaUsuario: new Pessoa(),
    pessoaProfissional: new Pessoa(),
    endereco: new Endereco(),
    url_baseArquivo: '',
    vModalCancelarLideranca: false,
    vModalLider: false,

    listaEquipe: []
  }

  componentDidMount() {
    this.iniciar();
  }

  async iniciar() {
    let pessoaUsuario = await this.util.buscarLocalStorage("PESSOA_USUARIO");
    let url_baseArquivo = await this.util.buscarUrlBaseArquivo;
    let parametro = await this.util.buscarParametros();
    let pessoaProfissional = new Pessoa();
    let retorno = await this.pessoaService.buscarPorSeqPessoa(parametro?.id);
    let endereco = new Endereco();

    if (retorno?.objeto?._seqPessoa) {
      pessoaProfissional = retorno.objeto
      retorno = await this.pessoaService.listarEndereco(pessoaProfissional);
      endereco = retorno.objeto[0];
    }

    let listarEquipe = await this.listarEquipe(pessoaProfissional)

    this.setState({
      pessoaUsuario: pessoaUsuario,
      pessoaProfissional: pessoaProfissional,
      url_baseArquivo: url_baseArquivo,
      endereco: endereco,
      listarEquipe: listarEquipe
    })
  }

  async tornarLider() {
    this.setState({ salvarCarregando: true });
    let pessoaProfissional = this.state.pessoaProfissional;
    pessoaProfissional.seqPessoaPerfil = this.constante.seqPessoaPerfilLider;
    let retorno = await this.pessoaService.salvar(pessoaProfissional);
    pessoaProfissional = retorno.objeto;

    this.toast.current.show([
      { severity: 'success', summary: ' Alteração armazenadas com sucesso!' },
    ]);
    this.setState({
      pessoaProfissional: pessoaProfissional,
      salvarCarregando: false
    })
  }

  async cancelarLideranca() {
    this.setState({ salvarCarregando: true });
    let pessoaProfissional = this.state.pessoaProfissional;
    pessoaProfissional.seqPessoaPerfil = this.constante.seqPessoaPerfilFaxineiro;
    let retorno = await this.pessoaService.salvar(pessoaProfissional);
    pessoaProfissional = retorno.objeto;

    this.toast.current.show([
      { severity: 'success', summary: ' Alteração armazenadas com sucesso!' },
    ]);
    this.setState({
      pessoaProfissional: pessoaProfissional,
      salvarCarregando: false,
    })
  }

  async listarEquipe(pPessoa) {
    let pessoaProfissional = pPessoa

    if (!pPessoa) {
      pessoaProfissional = this.state.pessoaProfissional
    }

    let retorno = await this.pessoaService.listarRelacionamento(pessoaProfissional)
    let listaEquipe = retorno.objeto

    this.setState({ listaEquipe: listaEquipe })

    return listaEquipe;

  }

  render() {
    return <div>
      <Dialog header="Alerta" visible={this.state.vModalLider} style={{ width: 400 }} onHide={() => this.setState({ vModalLider: false, })}>
        <div style={{ display: "flex", flexDirection: 'column', gap: 20 }}>
          <p>Deseja realmente transformar este profissional em líder?</p>
          <div style={{ display: 'flex', gap: 10, justifyContent: "right" }}>
            <Button label="Sim" onClick={() => {
              this.tornarLider();
              this.setState({ vModalLider: false, });
            }} />
            <Button label="Não" onClick={() => this.setState({ vModalLider: false, })} />
          </div>
        </div>
      </Dialog>


      <Dialog header="Alerta" visible={this.state.vModalCancelarLideranca} style={{ width: 400 }} onHide={() => this.setState({ vModalCancelarLideranca: false, })}>
        <div style={{ display: "flex", flexDirection: 'column', gap: 20 }}>
          <p>Deseja realmente cancelar a liderança deste líder?</p>
          <div style={{ display: 'flex', gap: 10, justifyContent: "right" }}>
            <Button label="Sim" onClick={() => {
              this.cancelarLideranca();
              this.setState({ vModalCancelarLideranca: false, });
            }} />
            <Button label="Não" onClick={() => this.setState({ vModalCancelarLideranca: false, })} />
          </div>
        </div>
      </Dialog>

      <HeaderSistema />
      <main style={{ width: "98%", margin: "20px auto" }}>
        <Toast ref={this.toast} />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 20,
            border: "1px solid lightgray",
            padding: 20,
            borderRadius: 3,
          }}
        >
          <Button
            style={{ backgroundColor: this.constante.corPrincipal, borderColor: this.constante.corPrincipal }}
            onClick={() => window.location.href = '/sistema/profissionais'}
            icon='pi pi-arrow-left'
          />
          <div>
            <h1 style={{ fontSize: 22, margin: 0 }}>Profissional detalhe</h1>
            <h2 style={{ fontSize: 20, color: 'gray', margin: 0 }}>Profissional detalhe</h2>
          </div>
        </div><br />

        <form
          onSubmit={e => {
            e.preventDefault();
          }}>

          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <i style={{ color: this.constante.corPrincipal, fontSize: '1rem', padding: 8, borderRadius: 360, border: `1px solid ${this.constante.corPrincipal}` }} className="pi pi-id-card" />
            <h3>Dados Pessoais</h3>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', border: '1px solid lightgray', padding: 10, borderRadius: 3, marginTop: 20, gap: 60 }}>
            {/* FOTO PROFISSIONAL */}
            <div style={{ width: 150, height: 150, backgroundColor: 'lightgray', borderRadius: 500, margin: '0px 0', display: 'flex', justifyContent: 'center', alignItems: "center", overflow: 'hidden' }}>
              {this.state.pessoaProfissional.foto ?
                <img
                  alt='Foto do profissional'
                  style={{ width: 150, height: 150, borderRadius: 500, backgroundColor: 'lightgray' }}
                  src={this.state.url_baseArquivo + this.state.pessoaProfissional.foto} />
                :
                <p>Sem foto</p>
              }
            </div>

            {/* DADOS PESSOAIS */}
            <div style={{ width: '100%', display: "grid", gridTemplateColumns: " 1fr 1fr 1fr", gap: 20, }}>
              <div>
                <label>Nome</label><br />
                <InputText
                  disabled
                  onChange={pTexto => this.setState({
                    pessoaProfissional:
                      { ...this.state.pessoaProfissional, nome: pTexto.target.value }
                  })}
                  value={this.state.pessoaProfissional.nome || ''}
                  style={{ width: '100%', height: 40 }} />
              </div>

              <div>
                <label>Nome fantasia</label><br />
                <InputText
                  disabled
                  onChange={pTexto => this.setState({
                    pessoaProfissional:
                      { ...this.state.pessoaProfissional, apelido: pTexto.target.value }
                  })}
                  value={this.state.pessoaProfissional.apelido || ''}
                  style={{ width: '100%', height: 40 }} />
              </div>

              {/* <div>
                <label>Perfil</label><br />
                <InputText
                  disabled
                  value={this.state.pessoaProfissional._perfilNome || ''}
                  style={{ width: '100%', height: 40 }} />
              </div> */}

              <div>
                <label>E-mail</label><br />
                <InputText
                  disabled
                  onChange={pTexto => this.setState({
                    pessoaProfissional:
                      { ...this.state.pessoaProfissional, emailPlataformaLirida: pTexto.target.value }
                  })}
                  value={this.state.pessoaProfissional.emailPlataformaLirida || ''}
                  style={{ width: '100%', height: 40 }} />
              </div>
            </div>
            {/* FIM DADOS PESSOAIS */}
          </div>


          {/* ENDEREÇO */}
          <div><br />
            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <i style={{ color: this.constante.corPrincipal, fontSize: '1rem', padding: 8, borderRadius: 360, border: `1px solid ${this.constante.corPrincipal}` }} className="pi pi-home" />
              <h3>Endereço</h3>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 20, border: '1px solid lightgray', padding: 10, borderRadius: 3, marginTop: 20 }}>
              <div>
                <label>CEP</label><br />
                <div className="p-inputgroup">
                  <InputText
                    disabled
                    onChange={e => this.setState({
                      endereco: {
                        ...this.state.endereco,
                        cep: this.util.formatarCEP(e.target.value),
                      }
                    })}
                    value={this.state.endereco?.cep || ''}
                    type="tel"
                    style={{ width: '100%', height: 40 }}
                  />
                  <Button
                    disabled
                    icon="pi pi-search"
                    type="button"
                    style={{ backgroundColor: this.constante.corPrincipal }}
                    onClick={() => this.buscarCep(this.state.endereco.cep)}
                  />
                </div>
              </div>


              <div>
                <label>Logradouro</label><br />
                <InputText
                  disabled
                  onChange={e => this.setState({
                    endereco: {
                      ...this.state.endereco,
                      logradouro: e.target.value,
                    }
                  })}
                  value={this.state.endereco?.logradouro || ''}
                  style={{ width: '100%', height: 40 }} />
              </div>

              <div>
                <label>Número</label><br />
                <InputText
                  disabled
                  onChange={e => this.setState({
                    endereco: {
                      ...this.state.endereco,
                      numero: e.target.value,
                    }
                  })}
                  value={this.state.endereco?.numero || ''}
                  style={{ width: '100%', height: 40 }} />
              </div>

              <div>
                <label>Complemento</label><br />
                <InputText
                  disabled
                  onChange={e => this.setState({
                    endereco: {
                      ...this.state.endereco,
                      complemento: e.target.value,
                    }
                  })}
                  value={this.state.endereco?.complemento || ''}
                  style={{ width: '100%', height: 40 }} />
              </div>

              <div>
                <label>Bairro</label><br />
                <InputText
                  disabled
                  onChange={e => this.setState({
                    endereco: {
                      ...this.state.endereco,
                      bairro: e.target.value,
                    }
                  })}
                  value={this.state.endereco?.bairro || ''}
                  style={{ width: '100%', height: 40 }} />
              </div>

              <div>
                <label>Cidade</label><br />
                <InputText
                  disabled
                  onChange={e => this.setState({
                    endereco: {
                      ...this.state.endereco,
                      cidade: e.target.value,
                    }
                  })}
                  value={this.state.endereco?.cidade || ''}
                  style={{ width: '100%', height: 40 }} />
              </div>

              <div>
                <label>Estado</label><br />
                <InputText
                  disabled
                  onChange={e => this.setState({
                    endereco: {
                      ...this.state.endereco,
                      estado: e.target.value,
                    }
                  })}
                  value={this.state.endereco?.estado || ''}
                  style={{ width: '100%', height: 40 }} />
              </div>

              <div>
                <label>UF</label><br />
                <InputText
                  disabled
                  onChange={e => this.setState({
                    endereco: {
                      ...this.state.endereco,
                      uf: e.target.value,
                    }
                  })}
                  value={this.state.endereco?.uf || ''}
                  style={{ width: '100%', height: 40 }} />
              </div>
            </div>
          </div>
          {/* FIM ENDEREÇO */}
        </form>

        <div style={{ border: '1px solid lightgray', padding: 10, borderRadius: 3, marginTop: 20 }}>
          <TabView style={{ marginTop: 10 }}>
            <TabPanel header="Perfil" >
              <div style={{
                widht: 'auto',
                display: 'flex',
                gap: 20,
                margin: '10px 0 40px 0'
              }}>
                {this.state.pessoaProfissional.seqPessoaPerfil === this.constante.seqPessoaPerfilLider ? <>
                  <div>
                    {/* <p>Tornou se lider em {this.util.formatarData(this.state.pessoaProfissional.dataVencimentoPagamento)}</p> */}
                    <Button
                      onClick={() => this.setState({ vModalCancelarLideranca: true })}
                      label="Cancelar liderança"
                      type="button"
                      className="p-button-raised p-button-danger"
                      loading={this.state.cancelarLiderancaCarregando}
                    />
                  </div>
                </> : <>
                  <div>
                    <Button
                      style={{ backgroundColor: this.constante.corPrincipal, borderColor: this.constante.corPrincipal }}
                      onClick={() => this.setState({ vModalLider: true })}
                      label="Transformar em líder"
                      type="button"
                      className="p-button-raised"
                      loading={this.state.salvarCarregando}
                    />
                  </div>
                </>}
              </div>
            </TabPanel>

            <TabPanel header="Dados bancários" >
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <div>
                  <label>Nome do responsável</label><br />
                  <InputText
                    disabled
                    style={{ width: '100%', height: 40 }}
                    value={this.state.pessoaProfissional.contaResponsavelNome} />
                </div>

                <div>
                  <label>CPF do responsável</label><br />
                  <InputText
                    disabled
                    style={{ width: '100%', height: 40 }}
                    value={this.state.pessoaProfissional.contaResponsavelCpf} />
                </div>

                <div>
                  <label>Banco</label><br />
                  <InputText
                    disabled
                    style={{ width: '100%', height: 40 }}
                    value={this.state.pessoaProfissional._contaNomeBanco} />
                </div>
                <div>
                  <label>Número Agência</label><br />
                  <InputText
                    disabled
                    style={{ width: '100%', height: 40 }}
                    value={this.state.pessoaProfissional.contaAgencia} />
                </div>
                <div>
                  <label>Dígito da agência</label><br />
                  <InputText
                    disabled
                    style={{ width: '100%', height: 40 }}
                    value={this.state.pessoaProfissional.contaDigitoAgencia} />
                </div>
                <div>
                  <label>Número da Conta</label><br />
                  <InputText
                    disabled
                    style={{ width: '100%', height: 40 }}
                    value={this.state.pessoaProfissional.contaNumeroConta} />
                </div>
                <div>
                  <label>Dígito da conta</label><br />
                  <InputText
                    disabled
                    style={{ width: '100%', height: 40 }}
                    value={this.state.pessoaProfissional.contaDigitoConta} />
                </div>
              </div>
            </TabPanel>

            <TabPanel header='Equipe'>
              <h3>Equipe</h3>
              <DataTable
                showGridlines
                removableSort
                paginator
                responsiveLayout="scroll"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                rows={50}
                rowsPerPageOptions={[50, 60, 70, 80, 100]}
                style={{ width: "100%", marginTop: 30 }}
                value={this.state.listaEquipe}
                loading={this.state.carregando}
              >
                <Column
                  header="Nome"
                  field="_pessoaRelacionadaNome"
                  sortable />

                <Column
                  header="Tipo de relacionamento"
                  field="_tipoRelacionamentoNome"
                  sortable />

                <Column
                  header="Data cadastro"
                  field="dataCadastro"
                  body={item => this.util.formatarData(item.dataCadastro)}
                  sortable />

              </DataTable>
            </TabPanel>
          </TabView>
        </div>
      </main>
    </div>
  }
}